import createRepository from '~/api/repositories/Repository'

export default (ctx, inject) => {
  inject('repositories', createRepository(ctx, ctx.$axios))
}